import { render, staticRenderFns } from "./OldUnionBar.vue?vue&type=template&id=403b4417&scoped=true&"
import script from "./OldUnionBar.vue?vue&type=script&lang=js&"
export * from "./OldUnionBar.vue?vue&type=script&lang=js&"
import style0 from "./OldUnionBar.vue?vue&type=style&index=0&id=403b4417&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403b4417",
  null
  
)

export default component.exports